import React, { Fragment } from "react"

let CodeThree = () => {

    return (
        <Fragment>
            <div className="cell code-cell">
                <div className="ace-github">
                    <div className="ace_static_highlight">
                        <div className="ace_line"><span className="ace_storage ace_type">let</span> <span
                            className="ace_identifier">path</span> <span
                            className="ace_keyword ace_operator">=</span> <span
                            className="ace_identifier">route</span><span
                            className="ace_punctuation ace_operator">.</span><span
                            className="ace_support ace_function">split</span><span
                            className="ace_paren ace_lparen">(</span><span className="ace_string">"/"</span><span
                            className="ace_paren ace_rparen">)</span><span
                            className="ace_punctuation ace_operator">;</span> <span className="ace_comment">// path is now assigned the value ["todos"]</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="ace_line"><br/></div>
        </Fragment>
    )

};

export default CodeThree;